import {IGeoLocationADS} from "modules/reducers";
import {IStore} from "modules/types/store";
import {createSelector} from "reselect";

export const getGeoLocationads = ({geoLocationAds}: IStore): IGeoLocationADS => geoLocationAds;

export const getUserAds = createSelector(getGeoLocationads, ({geoLocationAds}) => geoLocationAds);
